import { EmbedTokenRequest, EmbedTokenResponse, Report, UserReportAssignmentRequest, UserReportsRequest, UserReportsResponse, } from "@/types/report";
import axiosInstance from "./api";

export const getReports = async (): Promise<Report[]> => {
  const response = await axiosInstance.get('/Report/List');
  return response.data;
};

export const getReport = async (id: string): Promise<Report> => {
    const response = await axiosInstance.get<Report>(`/reports/${id}`)
    return response.data
  }

  export const getUserReports = async (request: UserReportsRequest): Promise<UserReportsResponse[]> => {
    const response = await axiosInstance.post('/Report/UserReports', request);
    return response.data;
  };

  export const getEmbedToken = async (request: EmbedTokenRequest): Promise<EmbedTokenResponse> => {
    const response = await axiosInstance.post(`/EmbedToken/${request.reportId}`, request);
    return response.data;
  };

  export const assignUsersToReport = async (request: UserReportAssignmentRequest[]) => {
    const response = await axiosInstance.post('/Report/AssignToUser', request);
    return response.data;
  };